import React, { useState, useEffect, useMemo } from 'react';
import { voiceoptions, channelIcons } from './constants.js';
import Confirm from './confirm';
const Projsettings = ({project, setProject, setTracks, PostSettingChange, dataprovider, show, setShow, allowTTSch, userinfo}) => {
  const [pnList, setPNList] = useState([]);
  const [newPN, setNewPN] = useState(0);
  const [talkUpdate, setTalkUpdate] = useState(false);
  const [voiceChanged, setVoiceChanged] = useState([]);
  const [confirmMsg, setConfirmMsg] = useState({});
  const [updateProgress, setUpdateProgress] = useState({});

  useEffect(() => {
    dataprovider.getList('codenumber', {}, setPNList);
  }, [dataprovider, newPN, show]);

  const handlePNChange = (pn) => {
    const pnNum = parseInt(pn);
    const it = pnList.find(it=>it.id===pnNum);
    if (!it.name) {
      setNewPN(pnNum);
    }
  }
  const ChangePN = () => {
    dataprovider.update('codenumber', {id:project.id, pn:newPN}, DonePNChange);
  }
  const DonePNChange = () => {
    setProject({...project, pn:newPN})
    setNewPN(0);
  }

  const doDelChannel = () => {
    dataprovider.update('track/deactivatechannels', {filter:{id_project:project.id}}, setTracks);
    setProject({...project, has_channels: 0});
    setConfirmMsg({});
  }
  const changeChannels = (ev) => {
    if (!ev.target.checked) {
      setConfirmMsg({msg:'Achtung: Die Tracks auf Kanal "Kreis" bleiben bestehen. Die Tracks auf den anderen Kanälen werden gelöscht! ', setMsg: setConfirmMsg, 
        buttons:[{text:'Abbrechen'},{typ:'primary',text:'Löschen', action:doDelChannel}]});  
    }
    else {
      dataprovider.update('track/activatechannels', {filter:{id_project:project.id}}, setTracks);
      setProject({...project, has_channels: 6, toggle: false});
    }
  }

  const changeImage = (v) => {
    const activate = v<0;
    if (v<0) v = 1;
    dataprovider.update('project/hasimage', {id:project.id, has_image:v, activate});
    let prset = {...project, has_image: v}; 
    if (activate) {
      prset.print_track = false;
      prset.print_title = true;
    }

    setProject(prset);
  }

  const setVoice = (n, prop) => (ev) => {
    if (!voiceChanged.includes(n)) {
      setVoiceChanged([...voiceChanged, n]);  
    }
    
    const v = ev.target.value;
    const voices = project.voices?JSON.parse(project.voices):[];
    if (!voices[0] || !voices[0].lang) voices[0] = { lang:'de-DE' };

    if (!voices[n]) voices[n] = {};
    if (prop==='lang') {
      if (voiceoptions[v]) {
        const k = Object.keys(voiceoptions[v].voice)[0];
        const x = voiceoptions[v].voice[k];
        voices[n].voice = k;
        voices[n].wavenet = x.voice;
        voices[n].pitch = x.pitch;
      }
      else {
        voices[n].voice = 'W';
      }
    }
    if (prop==='voice') {
      const lang = voices[n].lang?voices[n].lang:'de-DE';
      const x = voiceoptions[lang].voice[v];
      voices[n].wavenet = x.voice;
      voices[n].pitch = x.pitch;
    }
    voices[n][prop] = v;
    setProject({...project, voices:JSON.stringify(voices)})
  }
  const doneVoiceUpdate = (data) => {
    setTalkUpdate(false);
    setShow(false);
    setTracks(data);
  }
  const updateCodeProgress = (res) =>{
    const v = res.value;
    if (v) {
      const s = v.split('/');
      if (s.length>2) {
        const max = parseInt(s[1]);
        if (max > 0) {
          const pos = parseInt(s[0]);
          console.log(s)
          if (s[2]==='fertig') {
            setUpdateProgress({})  
          }
          else {
            setUpdateProgress({pos: Math.round(100/max * pos), text:s[2]})
            setTimeout(GetProgress, 500);
          }
        }
      }
    }
  }
  const GetProgress = () => {
    dataprovider.getRow('progress', 0, false, updateCodeProgress);
  }
  const close = () => {
    setVoiceChanged([]);
    setTalkUpdate(true);
    dataprovider.update('track/voiceupdate', {id:project.id, voices}, doneVoiceUpdate);
    setTimeout(GetProgress, 500);
  }

  const voices = useMemo(()=>project.voices?JSON.parse(project.voices):[], [project.voices]);

  if (!show) return null;
  return (
    <>
    <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">Druckeinstellungen für dieses Projekt definieren</h5>
            <button type="button" className="btn-close" onClick={close}></button>
          </div>
          <div className="modal-body">
            <table>
              <tbody>
                <tr>
                  <td>Anzahl Startsticker</td>
                  <td>
                    <select value={project.numstart} onChange={(ev)=>PostSettingChange('numstart', ev.target.value)} >
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td style={{padding: '.5em 1em .5em 0'}}>Tracknummer drucken</td>
                  <td>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={project.print_track} onChange={(ev)=>PostSettingChange('print_track', ev.target.checked)} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Tracktitel drucken</td>
                  <td>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={project.print_title} onChange={(ev)=>PostSettingChange('print_title', ev.target.checked)} />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">{project.sprachpaket?<>Sprachpakete für Kanäle (für Tiptoi)</>:<>Sprachauswahl der Talk-Tracks festlegen</>} &nbsp; &nbsp;
        {talkUpdate &&
              <svg className="circlespinner" viewBox="0 0 50 50" style={{position: 'relative', top:'-3px'}}>
                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
              </svg>
        }
        {updateProgress.text && 
          <div className="progress centered" role="progressbar" style={{height: "30px"}}>
            <div className="progress-bar" style={{width: updateProgress.pos+"%"}}></div>
            <p>{updateProgress.pos}% {updateProgress.text}</p>
          </div>
        }
            </h5>
          </div>
          <div className="modal-body">
  {project.sprachpaket && 
            <p>
              Die ausgewählten Sprachen und Stimmen werden auf die verschiedenen Kanäle
              geladen. Mit den Kanalstickern kann zwischen den Sprachen gewechselt werden.
              Hinweis: Die Übersetzungen werden automatisch generiert und müssen allenfalls
              noch manuell im Creator angepasst werden (v.a. im Schweizerdeutsch).
            </p>
  }            
            <table><tbody>
      {[0,1,2,3,4,5].map((n) => {
        const lang = voices[n] && voices[n].lang?voices[n].lang:(n===0?'de-DE':'');
        const voice = voices[n] && voices[n].voice?voices[n].voice:'W';
        const speed = voices[n] && voices[n].speed?voices[n].speed:1;
        return (
              <tr key={n}>
                <td>{project.sprachpaket?<i className={"bi bi-"+channelIcons[n]+" fs-5 me-2"} />:<>Stimme {n+1}:</>}</td>
                <td>
                  <select value={lang} onChange={setVoice(n, 'lang')} style={{width:'6em'}}>
          {n > 0 &&
                    <option value="">--</option>
          }
          {Object.keys(voiceoptions).map((lang) => (
                    <option value={lang} key={lang}>{voiceoptions[lang].name}</option>
          ))}
                  </select>
                </td>
                <td>
                  <select value={voice}  onChange={setVoice(n, 'voice')}>
                  {voiceoptions[lang] && voiceoptions[lang].voice.W &&
                    <option value="W">Frau (W)</option>
                  }
                  {voiceoptions[lang] && voiceoptions[lang].voice.M &&
                    <option value="M">Mann (M)</option>
                  }
                  {voiceoptions[lang] && voiceoptions[lang].voice.G &&
                    <option value="G">Mädchen (G)</option>
                  }
                  {voiceoptions[lang] && voiceoptions[lang].voice.B &&
                    <option value="B">Knabe (B)</option>
                  }
                  </select>
                </td>
              {voiceoptions[lang] && !voiceoptions[lang].nospeed &&
                <td>
                  <select value={speed} onChange={setVoice(n, 'speed')}>
                    <option value="0">Langsam</option>
                    <option value="1">Standard</option>
                    <option value="2">Schnell</option>
                  </select>
                </td>
              }
              </tr>
      )})}      
            </tbody></table>
          </div>
      {(!project.sprachpaket)  && <>
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">Kanäle aktivieren (nur für Tiptoi)</h5>
          </div>
          <div className="modal-body">
            <table>
              <tbody>
                <tr>
                  <td>
                    Mit den automatisch generierten Kanalstickern kannst du zwischen verschiedenen Kanälen (z.B. Sprachen) wechseln. Die einzelnen Kanäle erstellt du ganz normal in deinem Projekt.
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" role="switch" checked={project.has_channels>0} onChange={changeChannels} />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
  {project.has_channels>0 &&
            <table style={{marginTop:'1em'}}>
              <tbody>
                <tr>
                  <td style={{paddingRight: '1em'}}>Anzahl Kanäle</td>
                  <td>
                    <select value={project.has_channels} style={{minWidth:'3em'}} onChange={(ev)=>PostSettingChange('has_channels', ev.target.value)} >
    {[2,3,4,5,6].map((n) => (
                      <option value={n} key={n}>{n}</option>
    ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <td style={{paddingRight: '1em'}}>Anzahl Kanalsticker-Sets</td>
                  <td>
                    <select value={project.chanelsticker} style={{minWidth:'3em'}} onChange={(ev)=>PostSettingChange('chanelsticker', ev.target.value)} >
    {[0,1,2,3,4,5,6,7,8,9,10].map((n) => (
                      <option value={n} key={n}>{n}</option>
    ))}
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>      
  }            
          </div>
      </>}
    {!!userinfo.image &&
      <div className="modal-header">
        <table>
          <tbody>
            <tr>
              <td style={{padding: '0 1em 0 0'}}>
                <h5 className="modal-title" id="staticBackdropLabel">Bild / METACOM Symbole</h5>
              </td>
              <td>
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" checked={project.has_image} onChange={(ev)=>changeImage(ev.target.checked?-1:0)} />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    }
    {project.has_image>0 &&
      <div className="modal-body">
        <span className="me-3">Titelposition</span>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1" checked={project.has_image===1} onChange={(ev)=>changeImage(1)} /> 
          <label className="form-check-label" for="inlineRadio1">oben</label>
        </div>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="2" checked={project.has_image===2} onChange={(ev)=>changeImage(2)} />
          <label className="form-check-label" for="inlineRadio2">unten</label>
        </div>
        <table>
                        <tr>
                  <td style={{padding: '.5em 1em .5em 0'}}>Bildabstand zum Rahmen</td>
                  <td>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={project.image_padding} onChange={(ev)=>PostSettingChange('image_padding', ev.target.checked)} />
                    </div>
                  </td>
                </tr>
        </table>
      </div>
  }

      {(project.tiptoi_id<700 || project.tiptoi_id>899)  && <>
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">Projektnummer manuell ändern</h5>
          </div>
          <div className="modal-body">
            <p>Diese Option verwenden, wenn mehrere Lehrpersonen die gleichen Hörstifte oder Creator-Projekte verwenden. Mehr Infos unter Tipps <a href="/tipps/226" target="_blank">Team-Szenarien</a></p>
            <select value={project.pn} onChange={(ev)=>handlePNChange(ev.target.value)} style={{maxWidth:'100%'}}>
    {pnList.map((r)=>(
              <option value={r.id} key={r.id} style={r.id===project.pn?{color:'#0d6efd'}:(r.name?{color:'#CCC'}:{})}>PN {String(r.id).padStart(3, '0')} - {r.name}</option>
    ))}              
            </select>
          </div>
      </>}
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={close}>Übernehmen</button>
          </div>
        </div>
      </div>
    </div>
  {newPN > 0 && 
    <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">Achtung</h5>
            <button type="button" className="btn-close" onClick={()=>setNewPN(0)} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            Die Änderung der Projetnummer hat zur Folge, dass bereits ausgedruckte Soundsticker nicht mehr funktionieren und der Hörstift neu synchronisiert werden muss.
          </div>
          <div className="modal-footer">
            <button type="submit" className="btn btn-secondary mt-4 me-2" data-bs-dismiss="modal" onClick={()=>setNewPN(0)}>Abbrechen</button>
            <button type="submit" className="btn btn-primary mt-4" data-bs-dismiss="modal" onClick={ChangePN}>Ändern</button>
          </div>
        </div>
      </div>
    </div>
  }
    <Confirm msg={confirmMsg.msg} setMsg={setConfirmMsg} buttons={confirmMsg.buttons} />
    </>
  )
}
export default Projsettings;